import API from '../api/api'

const ADD_SERVICE_QUESTION = 'ADD_SERVICE_QUESTION'
const UPDATE_SERVICE_QUESTION = 'UPDATE_SERVICE_QUESTION'
const DELETE_SERVICE_QUESTION = 'DELETE_SERVICE_QUESTION'
const SET_SERVICES_QUESTIONS = 'SET_SERVICES_QUESTIONS'
const ADD_SERVICE_ANSWER = 'ADD_SERVICE_ANSWER'
const UPDATE_SERVICE_ANSWER = 'UPDATE_SERVICE_ANSWER'
const DELETE_SERVICE_ANSWER = 'DELETE_SERVICE_ANSWER'

const initialState = {
  questions: [],
}

const updatedQuestions = (state, action) =>
  state.questions.map((question) => {
    if (question.id === action.question.id) {
      return action.question
    }
    return question
  })

const serviceFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SERVICE_QUESTION:
      return {
        ...state,
        questions: [...state.questions, action.question],
      }
    case UPDATE_SERVICE_QUESTION:
      return {
        ...state,
        questions: state.questions.map((question) => {
          if (question.id === action.question.id) {
            return action.question
          }
          return question
        }),
      }
    case DELETE_SERVICE_QUESTION:
      return {
        ...state,
        questions: state.questions.filter((question) => question.id !== action.id),
      }
    case ADD_SERVICE_ANSWER:
      return {
        ...state,
        questions: updatedQuestions(state, action),
      }
    case UPDATE_SERVICE_ANSWER:
      return {
        ...state,
        questions: updatedQuestions(state, action),
      }
    case DELETE_SERVICE_ANSWER:
      return {
        ...state,
        questions: updatedQuestions(state, action),
      }
    case SET_SERVICES_QUESTIONS:
      return {
        ...state,
        questions: action.questions,
      }
    default:
      return state
  }
}

const setServicesQuestions = (questions) => {
  return {
    type: SET_SERVICES_QUESTIONS,
    questions,
  }
}

const addQuestion = (question) => {
  return {
    type: ADD_SERVICE_QUESTION,
    question,
  }
}

const updateQuestion = (question) => {
  return {
    type: UPDATE_SERVICE_QUESTION,
    question,
  }
}

const deleteQuestion = (id) => {
  return {
    type: DELETE_SERVICE_QUESTION,
    id,
  }
}

const addAnswer = (question) => {
  return {
    type: ADD_SERVICE_ANSWER,
    question,
  }
}

const updateAnswer = (question) => {
  return {
    type: UPDATE_SERVICE_ANSWER,
    question,
  }
}
const deleteAnswer = (question) => {
  return {
    type: DELETE_SERVICE_ANSWER,
    question,
  }
}

export const fetchServicesQuestions = () => {
  return (dispatch) =>
    API.getServicesQuestions()
      .then((res) => {
        dispatch(setServicesQuestions(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createServiceQuestion = (questionData) => {
  return (dispatch) =>
    API.createServiceQuestion(questionData)
      .then((res) => {
        dispatch(addQuestion(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateServiceQuestion = (answerData, id) => {
  return (dispatch) =>
    API.updateServiceQuestion(answerData, id)
      .then((res) => {
        dispatch(updateQuestion(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

// Lightweight order-only variant used by Up/Down and drag reordering, kept separate from
// updateServiceQuestion (the full-form Save action, still needed there to sync the canonical
// saved entity back into Redux). Deliberately does NOT re-dispatch the server's response on
// success: the new order is already applied optimistically to Formik's local state, and
// re-syncing here would let a slow response from an earlier reorder stomp a newer one that
// already changed this question's order client-side (two quick drags racing) — this PUT exists
// purely to persist, not to drive local state.
export const updateServiceQuestionOrder = (id, order) => {
  return () =>
    API.updateServiceQuestion({ order }, id).catch((err) => {
      return Promise.reject(err)
    })
}

export const deleteServiceQuestion = (id) => {
  return (dispatch) =>
    API.deleteServiceQuestion(id)
      .then(() => {
        dispatch(deleteQuestion(id))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createServiceAnswer = (answerData, questionId) => {
  return (dispatch) =>
    API.createServiceAnswer(answerData, questionId)
      .then((res) => {
        dispatch(addAnswer(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateServiceAnswer = (answerData, answerId, questionId) => {
  return (dispatch) =>
    API.updateServiceAnswer(answerData, answerId, questionId)
      .then((res) => {
        dispatch(updateAnswer(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const deleteServiceAnswer = (questionId, answerId) => {
  return (dispatch) =>
    API.deleteServiceAnswer(questionId, answerId)
      .then((res) => {
        dispatch(deleteAnswer(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const selectQuestions = (state) => state.serviceForm.questions

export default serviceFormReducer
